<template>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex md8 sm12>
          post content
          <v-card v-for="(post) in BloggerPosts" :title="post.title" v-bind:key="post.id" class="pa-2">
            <h5>Posted on {{post.published.split('T')[0]}}</h5><div v-html="post.content"> </div>
          </v-card>
        </v-flex>
        <v-flex md4 sm12>
          ads?
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
export default {
  data () {
    return {
      TestBlogPost:"",
      BloggerPosts:[]
    }
  },
  async created() {
      var self = this;
      var res = await this.$http.get("/blog/bad11/posts");
      this.BloggerPosts = res.data.items.slice(0,5);
  },
  methods: {
  }
}
</script>